@switch (clientId) {
@case (26) {
<ng-container *ngTemplateOutlet="mattamySMSConsent"></ng-container>
}
@case (124) {
<ng-container *ngTemplateOutlet="mattamySMSConsent"></ng-container>
}
@default {
<!-- Empty container for other client IDs -->
}
}

<ng-template #mattamySMSConsent>
  <div class="consent-container">
    <div class="checkbox-wrapper">
      <input type="checkbox" id="consentCheckbox" [ngModel]="isConsentChecked" (ngModelChange)="handleConsentChecked($event)">
      @if(isProduction) {
      <label for="consentCheckbox" class="consent-text">
        By entering your phone number above and clicking "Submit", you consent to receive recurring, personalized text messages and
        notifications from Mattamy Homes Limited (Canada)/Calben (US) Corporation (USA) concerning your relationship with us and our products,
        services, promotional offers and transactions that we think may interest you. Message and data rates may apply. Reply STOP, CANCEL,
        UNSUBSCRIBE, END, QUIT to cancel or HELP for help. You can unsubscribe at any time.
        In addition to using your information to send the messages and notifications described above, we may collect and use some of your
        information to evaluate and report on our SMS campaigns. Click to view our <a target="_blank"
           href="https://mattamyhomes.com/sms-privacy-policy">SMS Privacy Policy</a>, <a target="_blank"
           href="https://mattamyhomes.com/sms-terms-of-service">SMS Terms of Service</a> and <a target="_blank"
           href="https://mattamyhomes.com/privacy-policy">Privacy Policy</a>
        for more information, including regarding the data we collect about our SMS campaigns as well as the service providers and carriers we
        may share your information with to provide SMS services (some of which may be located outside the country where you are located).
      </label>
      }
      @if(!isProduction) {
      <label for="consentCheckbox" class="consent-text">
        By entering my phone number and/or email address and checking the box, I confirm I would like to receive promotional emails and/or text
        messages (SMS)
        from Mattamy Homes and its affiliates. Msg/data rates may apply. Consent is not a condition of purchase.
        I can opt out anytime (i.e. SMS: reply STOP or use any other method described in our <a target="_blank"
           href="https://mattamyhomes.com/sms-privacy-policy">SMS Privacy Policy</a>; email:
        use unsubscribe link). Mattamy and our providers may collect campaign engagement data to improve our marketing efforts.
        For more information, see our <a target="_blank" href="https://mattamyhomes.com/privacy-policy">Privacy Policy</a>, <a target="_blank"
           href="https://mattamyhomes.com/sms-privacy-policy">SMS Privacy Policy</a>, <a target="_blank"
           href="https://mattamyhomes.com/sms-terms-of-service">SMS Terms of Service</a>, and/or <a target="_blank"
           href="https://mattamyhomes.com/contact-us">Contact Us</a>.
      </label>
      }
    </div>
  </div>
</ng-template>